import React, { useContext, useEffect, useState } from "react";
import {
  getQuotation,
  deletePurchase,
  getQuotationorder,
  addQuotationOrder,
  updateQuotation,
  getQuotationOrderDetail
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { SalesForm, PurchaseorderForm } from "./form";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { useLocation, useNavigate } from "react-router-dom";
import { isReadonlyRoute, NaviGate, shop_id } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";

const Quotation_list = () => {
  const navigate = useNavigate();
  const [Purchase, setPurchase] = useState([]);
  const [ListModal, setListModal] = useState(false);
  const [PO_Data, setPO_Data] = useState([]);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showdeleteModal, setShowdeleteModal] = useState(false);
  const [showdeleteID, setShowdeleteID] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const { pathname } = useLocation();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const readonly = isReadonlyRoute(pathname);
  const { showLoader, hideLoader } = useContext(WarehouseContext);
  const [searchText, setSearchText] = useState("");
  const [resetDone, setResetDone] = useState(false); // flag to track when reset is complete
  const [activeTab, setActiveTab] = useState(0); // 'purchase', 'quotation', 'sales'
  const [SearchQurey, setSearchQurey] = useState('');


  const PurchasePerPage = 10;
  useEffect(() => {
    fetchPurchase(1, "");
  }, []);

  useEffect(() => {
    if (resetDone) {
      fetchPurchase(1, "");
      setResetDone(false); // reset the flag after fetching
    }
  }, [resetDone]);

  const fetchPurchase = async (page = 1, text = searchText) => {
    showLoader();
    try {
      showLoader();
      const filters = {
        from_date: fromDate,
        to_date: toDate,
        approval_status: activeTab?"1":"0"
      };

      console.log(text);
      const response = await getQuotation(page, text, shop_id, filters);
      if (response.data && response.data.data) {
        setPurchase(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
        hideLoader();
      }
    } catch (error) {
      console.error("Error fetching sales data:", error);
      toast.error("Error fetching sales");
      hideLoader();
    }
  };

  useEffect(() => {
    fetchPurchase(1); // Always reset to page 1 when tab changes
}, [activeTab, fromDate, toDate]);
  

const handleStatusChange = async (id, status) => {
  showLoader()
  try {
    const res_q = await getQuotationOrderDetail(id);
    const quotationItems = res_q.data?.data || [];

    const hasPendingShop = quotationItems.some(item => 
      item?.shop_id?.toLowerCase().includes("pending")
    );

    if (hasPendingShop) {
      toast.warning("Please view the quotation, commit new product, and approve.");
      return;
    }

    await updateQuotation(id, {
      approval_status: status
    });

    toast.success("Quotation status updated");
    fetchPurchase(1, "");
    hideLoader();
    setCurrentPage(1);
    
  } catch (error) {
    console.error("Error updating quotation status:", error);
    toast.error("Failed to update quotation status");
    hideLoader();

  }
};

  const handleFilter = (e) => {
    e.preventDefault();
    if (fromDate && !toDate) {
      toast.error("Please select To Date.");
      return;
    }
    
    if (toDate && !fromDate) {
      toast.error("Please select From Date.");
      return;
    }
    fetchPurchase();
  };

  const resetFilter = () => {
    setFromDate("");
    setToDate("");
    setSearchText("");
    setResetDone(true);
    setCurrentPage(1);
  };

  const handleDelete = async () => {
    try {
      await deletePurchase(showdeleteID);
      toast.success("Purchase deleted successfully");
      fetchPurchase();
      setShowdeleteModal(false);
    } catch (error) {
      console.error("Error deleting Purchase :", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchPurchase(pageNumber);
  };

  const handleSearch = async (text) => {
    if(text.length>3 || text.length == 0){
      setCurrentPage(1);
      fetchPurchase(1, text);
    }
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase">Quotation </h6>
          {!readonly && (
            <button
              type="button"
              onClick={() => (window.location.href = "/add_quotation")}
              className="btn btn-primary mb-0 text-normal rounded-1"
            >
              Add Quotation
            </button>
          )}
        </div>
        <hr className="mt-1" />

        <div className="card">
          <div className="card-body">
            <div className="row  align-items-between mb-3">
              <div className="col-12 col-md-6 col-lg-4 mb-2 mb-md-0 d-none">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search..."
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <img
                    src="/assets/images/icons/search.png"
                    alt="Search Icon"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      height: "18px",
                      pointerEvents: "none",
                    }}
                  />
                </div>
              </div>
              <div className="col-6 col-md-2 mb-2 mb-md-0">
                <div className="form-floating">
                  <input
                    type="date"
                    className="form-control"
                    value={fromDate}
                    max={toDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                  <label>From Date</label>
                </div>
              </div>

              {/* To Date */}
              <div className="col-6 col-md-2 mb-2 mb-md-0 ">
                <div className="form-floating">
                  <input
                    type="date"
                    className="form-control"
                    value={toDate}
                    min={fromDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                  <label>To Date</label>
                </div>
              </div>

              {/* Unique ID */}
              <div className="col-6 col-md-2 mb-2 mb-md-0 ">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      handleSearch(e.target.value);
                    }}
                    placeholder="e.g.QU-2025"
                  />
                  <label>Quotation ID:</label>
                </div>
              </div>

              {/* Filter Button */}
              <div className="col-6 col-md-2 mb-2 mb-md-0 d-flex flex-column align-items-start gap-1">
                <button
                  type="submit"
                  onClick={handleFilter}
                  className="btn btn-primary btn-sm px-2 py-1 w-auto"
                  style={{ fontSize: "0.75rem", minWidth: "100px" }}
                >
                  Filter
                </button>
                <button
                  type="button"
                  onClick={resetFilter}
                  className="btn btn-secondary btn-sm px-2 py-1 w-auto"
                  style={{ fontSize: "0.75rem", minWidth: "100px" }}
                >
                  Reset
                </button>
              </div>
            </div>
            <div className="card">
                  <div className="card-body">
                    {/* Approval Status Tabs */}
                    <ul className="nav nav-tabs text-end mb-3">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
                            onClick={() => {setActiveTab(1);
                                           setCurrentPage(1);
                                          }}
                        >
                            Approved
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 0? 'active' : ''}`}
                            onClick={() => {
                              setActiveTab(0);
                              setCurrentPage(1);
                            }}

                        >
                            UnApproved
                        </button>
                    </li>
                </ul>
            <div className="table-responsive">
              <table
                id="example"
                className="table table-sm table-striped table-bordered"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Quotation ID</th>
                    <th>Customer Name</th>
                    <th>Date & time </th>
                    {/* <th>Status</th> */}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {Purchase.length > 0 ? (
                    Purchase.map((item, index) => (
                      <tr key={item.purchase_id}>
                        <td>
                          {(currentPage - 1) * PurchasePerPage + index + 1}
                        </td>
                        <td>{item.quotation_number}</td>
                        <td>{item.customer_name}</td>
                        <td>{item.date}</td>
                        <td >
                          <img
                            src="/assets/images/icons/view.png"
                            className="me-4"
                            onClick={() =>
                              navigate("/quotation_pdf", { state: item })
                            }
                            style={{height: "16px"}}
                          />
                          {!readonly && (
                          item.approval_status == 0?
                          <button className="btn btn-success btn-sm"  onClick={()=>handleStatusChange(item.quotation_number,1)}>
    Approve
    </button >
                                
                            :

                            <button className="btn btn-danger btn-sm"  onClick={()=>handleStatusChange(item.quotation_number,0)}>
    Unapprove
    </button >
                        
                            )}

                          {/* <input
                            type="checkbox"
                            className={`form-check-input ${item.approved ? "bg-success" : ""}`}
                            checked={item.approved}
                            onChange={() => handleApprove(item)}
                            disabled={!item.quotation_number}
                          /> */}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="12" className="text-center">
                        No products found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
            </div>
            </div>
          </div>
        </div>
      </div>

      {showdeleteModal && (
        <Deletemodel
          setShowModal={setShowdeleteModal}
          handleDelete={handleDelete}
        />
      )}

      {ListModal && (
        <PurchaseorderForm
          selectedPurchase={selectedPurchase}
          PO_Data={PO_Data}
          onClose={() => setListModal(false)}
        />
      )}
    </div>
  );
};

export default Quotation_list;
